import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import _ from 'lodash';
import { EMPTY, Observable, Subject, combineLatest } from 'rxjs';
import { map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { PresentationType } from 'src/app/samwebDescription/samweb/settings/presentationType';
import { ExecuteToolbarAction } from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/toolbar-settings/toolbar-settings.actions';
import { ToolbarSettingsState } from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/toolbar-settings/toolbar-settings.state';
import { UserActionRemoteDto } from '../../../../../../generated/swagger';
import { UserActionTyp } from '../../../../../samwebDescription/samweb/userActions/userActions';

@Component({
   selector: 'samweb-toolbar-action-item',
   templateUrl: './toolbar-action-item.component.html',
   styleUrls: ['./toolbar-action-item.component.scss'],
})
export class ToolbarActionItemComponent implements OnInit, OnDestroy {
   @Input()
   public actionId: string;

   @Input()
   public brickInstanceId: string;

   @Input()
   public toolbarId: string;

   @Input()
   public state: any;

   @Input()
   public smallView: boolean;

   public actionContent$: Observable<UserActionRemoteDto>;
   public actionTyp$: Observable<UserActionTyp>;
   public actionTitleTranslation$: Observable<string>;
   public iconName$: Observable<string>;
   public presentationType$: Observable<PresentationType>;
   public isExecuting$: Observable<boolean>;
   private destroy$ = new Subject();

   constructor(private store: Store) {}

   ngOnInit() {
      this.actionContent$ = this.store
         .select(ToolbarSettingsState.getToolbarActionFn)
         .pipe(map((fn) => fn(this.brickInstanceId, this.toolbarId, this.actionId)));
      this.actionTyp$ = this.store
         .select(ToolbarSettingsState.getActionTypeForUserActionFn)
         .pipe(map((fn) => fn(this.brickInstanceId, this.toolbarId, this.actionId)));
      this.iconName$ = this.store.select(ToolbarSettingsState.getActionIconFn).pipe(map((fn) => fn(this.brickInstanceId, this.toolbarId, this.actionId)));
      this.presentationType$ = this.store.select(ToolbarSettingsState.getToolbarPresentationTypeFn).pipe(map((fn) => fn(this.brickInstanceId, this.toolbarId)));
      this.actionTitleTranslation$ = this.actionTyp$.pipe(switchMap((x) => x.getTranslationKey$(this.store)));
      this.isExecuting$ = this.actionTyp$.pipe(switchMap((x) => x.isExecuting$));

      combineLatest([
         this.actionTyp$,
         this.store.select(ToolbarSettingsState.getActionSettingFn).pipe(map((fn) => fn(this.brickInstanceId, this.toolbarId, this.actionId))),
      ])
         .pipe(
            switchMap(([actionType, actionSettings]) => {
               if (_.isNil(actionType) || _.isNil(actionSettings) || _.isNil(actionType.autoExecuteOnEmit$)) {
                  return EMPTY;
               }
               return actionType.autoExecuteOnEmit$(this.store, actionSettings as any);
            }),
            tap(() => this.store.dispatch(new ExecuteToolbarAction(this.brickInstanceId, this.toolbarId, this.actionId, this.store))),
            takeUntil(this.destroy$)
         )
         .subscribe();
   }

   ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
   }
}
